<template lang="html">
<div class="pgInner affairEdit">

    <div class="headBar">新建企业</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <div class="tabNavs" ref="tabNavs">
                <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                     {{item}}
                </div>
                <div class="moveLine" :style="lineStr"></div>
           </div>

           <div class="tabContent">
                <Subpage1 @inited="readyHandle" :entid="postPms1.id" ref="subpage1" v-show="navAct===0" />
                <Subpage2 @inited="readyHandle" :entid="postPms1.id" ref="subpage2" v-show="navAct===1" />
                <Subpage3 @inited="readyHandle" :entid="postPms1.id" ref="subpage3" v-show="navAct===2" />
           </div>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="goReturn" plain size="small">取消</el-button>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
      </div>

    </div>

</div>
</template>

<script>
import { enterpriseCreate, addressSave, serviceSave, getEnterprise, goEntMetts } from "@/api/enterprise/index";
import Subpage1 from "./src/Subpage1";
import Subpage2 from "./src/Subpage2";
import Subpage3 from "./src/Subpage3";

export default {
  components: {
    Subpage1,
    Subpage2,
    Subpage3
  },
  computed: {
    lineStr: function () {
      var str = 'width:60px;';
      str = str + "left:" + this.navX + "px;";
      return str;
    },
    pgState: function () {
      var state = 0;
      if (this.id && this.readyKey !== 3) {
        state = 1;
      }

      if (this.uploadIng) {
        state = 2;
      }

      return state;
    }
  },
  data() {
    return {
      id: '',
      navs: ['基本信息', '认证信息', '主页信息'],
      navAct: 0,
      navX: 15,
      pageH: '',
      readyKey: 0,
      uploadIng: false,
      postPms1: {
        id: ''
      },
      postPms2: {
        cqjQiyeEnterpriseId: ''
      }

    }
  },

  methods: {
    goReturn: function () {
      this.$router.go(-1);
    },

    tabChange: function (e, inx) {

      var tabNavs = this.$refs.tabNavs;
      this.navAct = inx;
      this.navX = e.target.offsetLeft;

    },
    pageFix: function () {
      this.pageH = document.documentElement.clientHeight - 205;
    },
    prevSet: function () {

      var vues = this;
      var querys = this.$route.query;

      // 底部定位
      this.pageFix();

      // 获取初始 ID
      if (querys.id) {
        vues.id = querys.id;
        vues.postPms1.id = querys.id;
        vues.postPms2.cqjZhengwuHandleMattersId = querys.id;

        getEnterprise({ id: querys.id }).then(res => {
          vues.id = querys.id;
          vues.$refs.subpage1.preEdit(res);
          vues.$refs.subpage2.preEdit(res);
          vues.$refs.subpage3.preEdit(res);
          vues.readyKey = 3;
        })

      } else {
        enterpriseCreate().then(res => {
          vues.postPms1.id = res.enterprise.id;
          vues.postPms2.cqjQiyeEnterpriseId = res.enterprise.id;
        }).catch(err => { });
      }

    },

    readyHandle: function () {
      this.readyKey++;
    },

    directSave: function (status) {
      var vues = this;
      var wait = this.$refs.subpage1.saveReturn();

      function goSave(res) {
        var pms1 = res;
        var pms2 = vues.$refs.subpage2.saveReturn();
        var pms3 = vues.$refs.subpage3.saveReturn();

        if (!pms1) {
          vues.$message.error('基本信息未填写完成！');
        } else {
          var promiseArr = [];

          vues.uploadIng = true;

          promiseArr.push(new Promise((resolve, reject) => {    // 基本信息
            var pms = $.extend({}, vues.postPms1, pms1, pms3.pms);
            if (!pms.status) {
              pms.status = 2;
            }
            enterpriseCreate({ enterprise: pms }).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
          }))

          if (pms2) {
            promiseArr.push(new Promise((resolve, reject) => {    // 认证消息
              if (!pms2.status) {
                pms2.cqjQiyeEnterpriseId = vues.postPms1.id;
                pms2.companyName = pms1.companyName;
              }
              goEntMetts({ enterpriseCertificationInfo: pms2 }).then(res => {
                resolve(res);
              }).catch(err => {
                reject(err);
              })
            }))
          }

          if (pms3.adsList.length > 0) {
            promiseArr.push(new Promise((resolve, reject) => {    // 办公地址
              addressSave({ enterpriseOfficeAddressList: pms3.adsList }).then(res => {
                resolve(res);
              }).catch(err => {
                reject(err);
              })
            }))
          }

          if (pms3.svcList.length > 0) {
            promiseArr.push(new Promise((resolve, reject) => {    // 业务咨询
              pms3.svcList.forEach(item => {
                item.cqjQiyeEnterpriseId = vues.postPms1.id;
              })
              serviceSave({ enterpriseBusinessAdvisoryList: pms3.svcList }).then(res => {
                resolve(res);
              }).catch(err => {
                reject(err);
              })
            }))
          }

          Promise.all(promiseArr).then(res => {
            vues.uploadIng = false;
            vues.$router.push('ent_list');
          }).catch(err => {
            vues.uploadIng = false;
          })

        }
      }


      wait.then(res => {
        goSave(res);
      })
    }

  },
  created: function () {
    var vues = this;
    var querys = this.$route.query;

    this.prevSet();
    $(window).resize(function () {
      vues.pageFix();
      if (vues.$refs.scroller.$data) {
        vues.$refs.scroller.$data.sizeHeight = this.pageH;
      }

    })

  }


}
</script>

<style lang="scss" scoped>
.pgInner {
  background: #f5f5f5;
}

.headBar {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.tabNavs {
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem {
    float: left;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    margin-right: 45px;
    cursor: pointer;
  }
  .tabItem.act {
    color: rgb(86, 119, 252);
  }
  .moveLine {
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent {
  padding: 20px;
  background: white;
}

.pagefoot {
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn {
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1 {
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2 {
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading {
    font-size: 14px;
    padding-left: 24px;
    color: #aeaeae;
    i {
      font-size: 18px;
      vertical-align: middle;
    }
  }
}
</style>

<style lang="css">
.affairEdit .pgbody {
  margin: 20px;
  background: white;
}

@media only screen and (max-width: 1366px) {
  .affairEdit .pgbody {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// enterpriseEdit.vue?277c18cf